import Logger from '@/utils/Logger.js';

class Helpers {
	
	static isAndroid () {
		return navigator.userAgent.toLowerCase().indexOf("android") > -1;
	}
	
	static notLessThan (ms) {
		return new Promise((resolve) => {
			setTimeout(resolve,  ms);
		});
	}
	
	static k2m (meters) {
		return Math.ceil(meters / 1609.34);
	}
	
	static m2m (meters) {
		return Math.ceil(meters / 1000);
	}
	
	static loadScript (src, { onload = null, scriptDefer = true } = {}) {
		return new Promise((resolve) => {
			let gm = document.createElement('script');
			gm.setAttribute('src', src);
			if (onload !== null) {
				gm.onload = onload;
			}
			if (scriptDefer) {
				gm.setAttribute('defer', '');
			}
			document.head.appendChild(gm);
			resolve(true);
		});
	}
	
	static loadScriptAndWait (src, { scriptDefer = true } = {}) {
		return new Promise((resolve) => {
			let gm = document.createElement('script');
			gm.setAttribute('src', src);
			if (scriptDefer) {
				gm.setAttribute('defer', '');
			}
			gm.onload = resolve;
			document.head.appendChild(gm);
		});
	}
	
	static askForGeolocation () {
		return new Promise ((resolve) => {			
			if (navigator.geolocation) {
				let tm = setTimeout(() => {
					return resolve([false, null]);
				}, 5000);
				navigator.geolocation.getCurrentPosition((position) => {
					clearTimeout(tm);
					resolve([true, position]);
				}, () => {
					return resolve([false, null]);
				});
			} else {
				return resolve([false, null]);
			}
		});
	}
	
	static getLanguage () {
		let lang = navigator.language || navigator.userLanguage; 
		Logger.info('Detected language', lang);
		if (!lang === null) {
			return null;
		}
		return lang.split('-')[0];
	}
	
}

export default Helpers;